import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__EXTRACT_AND_MODIFY_URL } from 'PipeRouter';
import extractAndModify from './extractAndModify';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__EXTRACT_AND_MODIFY_URL);

    yield put({ type: cmd, data });
  }
}

export default function*() {
  yield all([
    pipeline(),
    extractAndModify()
  ]);
}
